"use client"
import { makeStyles } from "@material-ui/core/styles"
import Colors from "../../../common/Colors"
import Text from "../../../components/Text"
import { Box } from "@mui/material"

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  media: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
})

function FoodCard({ item, selectedCatagoryIndex, selectCategory, index }) {
  const classes = useStyles()

  const truncateText = item.category_name.length >12 ? `${item.category_name.substring(0, 12)}...` : item.category_name

  return (
    <Box className="">
      <Box
        sx={{
          // padding: "10px",
          backgroundColor: selectedCatagoryIndex == index ? Colors.primary : "#02111B",
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          margin: "3px",
          borderRadius: "5px",
          aspectRatio: "1/1", // This maintains square shape
          width: "140px", 
          height:"100px",
          border: "1px solid #FFC857",
          "&:hover": {
            opacity: "0.7",
            border: "1px solid " + Colors.primary,
          },
        }}
        onClick={() => {
          selectCategory(index)
        }}
      >
        <img
          src={item.category_image || "/placeholder.svg"}
          style={{
            width: "50px",
            height: "50px",
            objectFit: "cover",
          }}
        />
        <Box>
          <Text semibold center color={selectedCatagoryIndex == index ? Colors.blackColor : Colors.white}>
            {truncateText}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export default FoodCard

